import { CalendarDate, parseDate } from "@internationalized/date";
import dayjs, { ConfigType } from "dayjs";

export function toCalendarDate(value: ConfigType): CalendarDate | undefined {
  const date = dayjs(value);
  if (!date.isValid()) return undefined;
  return parseDate(date.format("YYYY-MM-DD"));
}
